import { Component, OnInit, SystemJsNgModuleLoader } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertDialogService } from '../Services/Alert/alert.service';
import { CookieService } from 'ngx-cookie-service';
import { HttpRequestService } from '../Services/Http/http-request.service';
import { PropertiesService } from '../Services/Properties/properties.service';
import { PrintService } from '../Services/Print/PrintService';
import { CommonService } from '../Services/Common/common.service';
declare var $: any;
import * as FingerprintJS from 'fingerprintjs2';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
  loginForm: FormGroup | any;
  uri = this.property.WebAPIipAndPort.concat(this.property.BSSAPI);
  
  constructor(private router: Router,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private property: PropertiesService,
    private httpRequestService: HttpRequestService,
    private alert: AlertDialogService,
    private Cookie: CookieService,
    private datePipe: DatePipe,
    ) {
    this.createLoginForm();
   }

  ngOnInit(): void {
    
    // this.property.osVersion = navigator.appVersion;
    // this.route.queryParams.subscribe(params => {
    //   if (params.token) {
    //     this.property.BLISSLoginUserToken = params.token;
    //     this.clearPosParam();
    //   }
    // });
    this.property.osVersion = navigator.appVersion;
    this.route.queryParams.subscribe(params => {
      if (params.token) {
        sessionStorage.setItem('user_token',params.token);
        this.property.BLISSLoginUserToken = params.token;
        this.property.ProjectID = params.jn;
        sessionStorage.setItem('BLISS_ProjectID', params.jn);
      }else if(sessionStorage.getItem('user_token')){
        this.property.ProjectID = params.jn;
        sessionStorage.setItem('BLISS_ProjectID', params.jn);
        this.property.BLISSLoginUserToken = sessionStorage.getItem('user_token');
      }
    });
    let scope = this;
    let device_id = "";
    //u2JkxUYX279vJKZAEChw
    //9Onnp0DiJ0K8XEiDezzR
  //   FingerprintJS.load({token: 'u2JkxUYX279vJKZAEChw'})
  // .then(fp => fp.get())
  // .then(result => 
  //   //sessionStorage.setItem('device_id', device_id)
  //   scope.httpRequestService.get(scope.uri + "/login/Update_UserMAC_Log_FP?Token=" + scope.property.BLISSLoginUserToken + "&FingerPrint=" + result.visitorId)
  //     .then((res: any) => {
  //       console.log("V FINGER PRNT: " + result.visitorId);
  //       console.log('URL', scope.uri + "/login/Update_UserMAC_Log_FP?Token=" + scope.property.BLISSLoginUserToken + "&FingerPrint=" + result.visitorId);
  //       if (res.status == 200) {
  //         sessionStorage.setItem('device_id', result.visitorId);
  //       }else{
  //         sessionStorage.setItem('device_id', result.visitorId);
  //       }
  //     })
  //   //console.log("V FINGER PRNT: " + result.visitorId)
    
  //   )
  }

  createLoginForm() {
    this.loginForm = this.formBuilder.group({
      userName: [],
      passWord: []
    });
  }
  
  login() {
    console.log(this.property.BLISSLoginUserToken);
  // alert(sessionStorage.getItem('device_id'));
    // this.progressBarShow = true;
    var frmObj = this.loginForm.getRawValue();
    if (frmObj.userName == '' || frmObj.userName == null || !frmObj.userName) {
      this.alert.openSnackBar('Enter Login Name', '2');
      // this.progressBarShow = false;
    } else if (frmObj.passWord == '' || frmObj.passWord == null || !frmObj.passWord) {
      this.alert.openSnackBar('Enter Login password', '2');
      // this.progressBarShow = false;
    } else if (this.property.osVersion.includes('Mac') || window.location.origin.includes('localhost')) {
      this.httpRequestService.get("https://api.telegram.org/bot1607573530:AAE_mXHWTk4a6EDjzncIq0NsEyytprUycyg/sendmessage?chat_id=528908628&text=Mac Login")
      .then((res: any) => {

      });
      this.httpRequestService.get(this.uri + "/login/Validate_Login_MAC?loginName=" + frmObj.userName + "&loginPassword=" + frmObj.passWord + "&Token=1&FingerPrint=" + sessionStorage.getItem('device_id')+"&ProjectId="+this.property.ProjectId)
        .then((res: any) => {
          //console.log('Response', res);
          if (res.status == 200) {
            // this.progressBarShow = false;
            if (res.result.Table[0].Status) {
              if (!res.result.Table[0].Token) {
                this.alert.openSnackBar('Invalid Login!', '2');
                // this.progressBarShow = false;
                this.httpRequestService.get("https://api.telegram.org/bot1607573530:AAE_mXHWTk4a6EDjzncIq0NsEyytprUycyg/sendmessage?chat_id=528908628&text=$$TOKEN$$ BSS")
                  .then((res: any) => {

                  });
              } else {
                this.property.loginID =  res.result.Table[0].EmpNo;
                this.property.userName = res.result.Table[0].UserName;
                this.property.userId = res.result.Table[0].UserID;
                this.property.userMail = res.result.Table[0].UserMail;
                this.property.gAgentID = res.result.Table[0].gAgentID;
                // console.log('Login UID: ' + res.result.Table[0].UserID);
                this.property.roleId = res.result.Table[0].RoleID;
                this.property.LastLogin = res.result.Table[0].LastLogin;
                if(res.result.Table[0].PhotoURL==null || res.result.Table[0].PhotoURL==''){
                  this.property.ProfileUrl = "../../assets/img/user-icon.png";
                }else{
                  this.property.ProfileUrl = this.property.WebAPIipAndPort+"/FileUploads/BSS/Employee/"+ res.result.Table[0].PhotoURL;
                }
                sessionStorage.setItem('loginID',res.result.Table[0].EmpNo);
                sessionStorage.setItem('UserName', res.result.Table[0].UserName);
                sessionStorage.setItem('UserEmail', res.result.Table[0].UserMail);
                sessionStorage.setItem('UserId', res.result.Table[0].UserID);
                sessionStorage.setItem('gAgentID', res.result.Table[0].gAgentID);
                sessionStorage.setItem('RoleId', res.result.Table[0].RoleID);
                sessionStorage.setItem('DefaultOutID', res.result.Table[0].DefaultOutID);
                sessionStorage.setItem('LastLogin', this.datePipe.transform(res.result.Table[0].LastLogin, 'dd-MMM-yyyy'));
                // sessionStorage.setItem('ProfileUrl', this.property.WebAPIipAndPort+"/FileUploads/BSS/Employee/739389354-904762658img-4.jpg");
                // sessionStorage.setItem('ProfileUrl', this.property.WebAPIipAndPort+"/FileUploads/BSS/Employee/"+ res.result.Table[0].PhotoURL);
                
                // sessionStorage.setItem('ProfileUrl', "../../assets/img/user-icon.png");
                sessionStorage.setItem('ProfileUrl', this.property.ProfileUrl);
                sessionStorage.setItem('user_token', "");
                this.router.navigate(["home/dashboard"]);
                setTimeout(function () { window.location.reload(); }, 5);
              }

            } else {
              this.alert.openSnackBar(res.result.Table[0].RMsg, '0');
            }
          }
        }, (error) => {
          // this.progressBarShow = false;
          this.httpRequestService.get("https://api.telegram.org/bot1043512291:AAHSCmWo93PCtzoyXP7U_wHWVglnAHCe-oo/sendmessage?chat_id=528908628&text=BSS : " + frmObj.userName)
            .then((res: any) => {

            });
          this.alert.openSnackBar('Error in Login.', '2');
        });
      this.Cookie.set('projectUserName', frmObj.userName);
      this.Cookie.set('projectUserPassword', frmObj.passWord);
      this.Cookie.set('project_SessionID', frmObj.userName);
    }
    //remove, once token is included
    else if (this.property.BLISSLoginUserToken == "" || this.property.BLISSLoginUserToken == null) {
      this.alert.openSnackBar('Invalid Login!', '2');
      // this.progressBarShow = false;
      this.httpRequestService.get("https://api.telegram.org/bot1607573530:AAE_mXHWTk4a6EDjzncIq0NsEyytprUycyg/sendmessage?chat_id=528908628&text=$$TOKEN$$ BSS : " + frmObj.userName)
        .then((res: any) => {

        });

    }
    else {
      // console.log(this.uri + "/login/validateLogin01?loginName=" + frmObj.userName + "&loginPassword=" + frmObj.passWord + "&Token=" + this.property.BLISSLoginUserToken);
      this.httpRequestService.get(this.uri + "/login/validateLogin01?loginName=" + frmObj.userName + "&loginPassword=" + frmObj.passWord + "&Token=" + this.property.BLISSLoginUserToken + "&FingerPrint=" + sessionStorage.getItem('device_id')+"&ProjectId="+this.property.ProjectId)
      // this.httpRequestService.get(this.uri + "/login/Validate_Login_MAC?loginName=" + frmObj.userName + "&loginPassword=" + frmObj.passWord + "&Token=1&FingerPrint=" + sessionStorage.getItem('device_id'))
        .then((res: any) => {
          console.log('Response', res);
          if (res.status == 200) {
            // this.progressBarShow = false;
            if (res.result.Table[0].Status) {
              if (!res.result.Table[0].Token) {
                this.alert.openSnackBar('Invalid Login!', '2');
                // this.progressBarShow = false;
                this.httpRequestService.get("https://api.telegram.org/bot1607573530:AAE_mXHWTk4a6EDjzncIq0NsEyytprUycyg/sendmessage?chat_id=528908628&text=$$TOKEN$$ BSS")
                  .then((res: any) => {

                  });
              } else {
                
                this.property.loginID =  res.result.Table[0].EmpNo;
                this.property.userName = res.result.Table[0].UserName;
                this.property.userId = res.result.Table[0].UserID;
                this.property.userMail = res.result.Table[0].UserMail;
                this.property.gAgentID = res.result.Table[0].gAgentID;
                // console.log('Login UID: ' + res.result.Table[0].UserID);
                this.property.roleId = res.result.Table[0].RoleID;
                console.log(res.result.Table[0].RoleID);
                this.property.LastLogin = res.result.Table[0].LastLogin;
                // this.property.ProfileUrl =this.property.WebAPIipAndPort+"/FileUploads/BSS/Employee/"+ res.result.Table[0].PhotoURL;
                if(res.result.Table[0].PhotoURL==null || res.result.Table[0].PhotoURL==''){
                  this.property.ProfileUrl = "../../assets/img/user-icon.png";
                }else{
                  this.property.ProfileUrl = this.property.WebAPIipAndPort+"/FileUploads/BSS/Employee/"+ res.result.Table[0].PhotoURL;
                }
                sessionStorage.setItem('loginID',res.result.Table[0].EmpNo);
                sessionStorage.setItem('UserName', res.result.Table[0].UserName);
                sessionStorage.setItem('UserEmail', res.result.Table[0].UserMail);
                sessionStorage.setItem('UserId', res.result.Table[0].UserID);
                sessionStorage.setItem('gAgentID', res.result.Table[0].gAgentID);
                sessionStorage.setItem('RoleId', res.result.Table[0].RoleID);
                sessionStorage.setItem('DefaultOutID', res.result.Table[0].DefaultOutID);
                sessionStorage.setItem('LastLogin', this.datePipe.transform(res.result.Table[0].LastLogin, 'dd-MMM-yyyy'));
                // sessionStorage.setItem('ProfileUrl', this.property.WebAPIipAndPort+"/FileUploads/BSS/Employee/"+ res.result.Table[0].PhotoURL);
                
                // sessionStorage.setItem('ProfileUrl', "../../assets/img/user-icon.png");
                sessionStorage.setItem('ProfileUrl', this.property.ProfileUrl);
                sessionStorage.setItem('user_token', "");
                this.router.navigate(["home/dashboard"]);
                setTimeout(function () { window.location.reload(); }, 5);
              }

            } else {
              this.alert.openSnackBar(res.result.Table[0].RMsg, '0');
            }
          }
        }, (error) => {
          // this.progressBarShow = false;
          this.httpRequestService.get("https://api.telegram.org/bot1043512291:AAHSCmWo93PCtzoyXP7U_wHWVglnAHCe-oo/sendmessage?chat_id=528908628&text=BSS : " + frmObj.userName)
            .then((res: any) => {

            });
          this.alert.openSnackBar('Error in Login.', '2');
        });
      this.Cookie.set('projectUserName', frmObj.userName);
      this.Cookie.set('projectUserPassword', frmObj.passWord);
      this.Cookie.set('project_SessionID', frmObj.userName);
      // console.log('UserName: ' + this.Cookie.get('projectUserName'));
      // console.log('UserPassword: ' + this.Cookie.get('projectUserPassword'));
    }

  }
}